export default {
    BASE_URL: '/sob/fincialCountManage',
    api: [
      {
        name: 'initCondition',
        path: '/initCondition',
        method: 'GET',
        desc: '列表条件加载'
      },
      {
        name: 'initConditionV2',
        path: '/initConditionV2',
        method: 'GET',
        desc: '列表条件加载(旧版)'
      },
      {
        name: 'complexList',
        path: '/complexList',
        method: 'POST',
        desc: '财务综合列表查询'
      },
      {
        name: 'expComplexList',
        path: '/expComplexList',
        method: 'POST',
        desc: '财务列表导出'
      },
      {
        name: 'standingBookList',
        path: '/standingBookList',
        method: 'POST',
        desc: '台账统计列表查询'
      },
      {
        name: 'expStandingBookList',
        path: '/expStandingBookList',
        method: 'POST',
        desc: '台账统计列表导出'
      },
    ]
  }



// WEBPACK FOOTER //
// ./src/api/apis/self/statistics/finance.js